var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHead = function SvgHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 44.5715C38.8365 44.5715 46 42.1513 46 39.166C46 36.1806 38.8365 33.7605 30 33.7605C21.1634 33.7605 14 36.1806 14 39.166C14 42.1513 21.1634 44.5715 30 44.5715Z",
    fill: "#2D3336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.644 36.5322L19.8167 38.4467C19.8167 40.3476 24.3769 41.8863 30 41.8863C35.623 41.8863 40.1832 40.3449 40.1832 38.4467L40.356 36.5322C38.3298 37.7598 34.4529 38.5873 30 38.5873C25.5471 38.5873 21.6701 37.7571 19.644 36.5322V36.5322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 16.0001C23.4503 16.0001 18.144 17.7929 18.144 20.0075C18.144 20.0859 18.1519 20.1617 18.165 20.2374L19.3089 32.8493L19.644 36.5349C21.6702 37.7626 25.5472 38.59 30 38.59C34.4529 38.59 38.3299 37.7599 40.3561 36.5349L40.6911 32.8493L41.8351 20.2374C41.8482 20.1617 41.8561 20.0832 41.8561 20.0075C41.8561 17.7929 36.5498 16.0001 30 16.0001Z",
    fill: "#2D3336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_1306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28.5714,
    fill: "white",
    transform: "translate(14 16)"
  })))));
};
export default SvgHead;